import { Controller } from "@hotwired/stimulus"

// Stub controller used only in Lookbook previews to simulate a page-level
// outer controller (e.g. a future reseller ToS gate) that co-exists with
// billing--terms-acceptance on the same form element.
//
// Demonstrates that PolicyItem always uses billing--terms-acceptance for its
// own targets and behavior regardless of what other controllers are present.
//
// Do not add behavior here — this controller is intentionally inert.
export default class extends Controller {}
